import React from 'react';
import PropTypes from 'prop-types';

const AccessibilityMain = ({children}) => {
  return (
    <main
      id="main-content"
      slot="body"
      tabIndex="-1"
    >
      {children}
    </main>
  );
};

AccessibilityMain.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccessibilityMain;

